import HCRender from "aldoo-ra/HelpCenter/hc-render"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const Header = ({ searchState, onSearchResultSelect, isHomePage }) => {
  const Search = HCRender.getFragment("Search")
  const texts = TextBundle({ id: "help-center" })

  return (
    <div className="w-full">
      <div className="relative w-full max-w-w2_xl h-[200px] md:h-[290px] rounded-[30px] md:rounded-[50px] bg-gradient-to-br from-primary/10 via-secondary/20 to-primary_lt/40 border-2 border-theme_white/50 shadow-sm p-4 mt-12 mx-auto">
        <div className="relative w-full h-full flex flex-col items-center justify-center z-20 mx-auto">
          <Typography
            variant="h1"
            // the page's heading on the home only; an article or category has its own
            component={isHomePage ? "h1" : "p"}
            className="text-3xl text-text text-center mb-6 md:mb-8"
          >
            {texts?.header_title}
          </Typography>

          {Search && (
            <Search searchState={searchState} onResultSelect={onSearchResultSelect} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
